
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqbuOIElHkSS9tiHUb3TcEzSI7ohBv71CrvNqbQfVG6yUMeta } from "/codebuild/output/src296139272/src/src/pages/faq.vue?macro=true";
import { default as menu1T_45V9TPVSwssIzSjqiUS8jTHtH3E8FnGFhnsls6Pt7sMeta } from "/codebuild/output/src296139272/src/src/pages/menu.vue?macro=true";
import { default as indextKkocOkBoDt_45wgiEhv9Yr2ElwoeB3I9Ch9IQhEPpIpMMeta } from "/codebuild/output/src296139272/src/src/pages/index.vue?macro=true";
import { default as contactgJ59k9FOQTkAXy2rVuKYxP2cGdt3mNvSijqetw33yegMeta } from "/codebuild/output/src296139272/src/src/pages/contact.vue?macro=true";
import { default as tutorialLwmMiSsRxICL75WJAOYScYQ9HB1EZH4bIfMHN9yTxRgMeta } from "/codebuild/output/src296139272/src/src/pages/tutorial.vue?macro=true";
import { default as agreementYNcV02NBYqV5bpf_45_45iIWG7jFFb2d6_crKvLCfDRRtP0Meta } from "/codebuild/output/src296139272/src/src/pages/agreement.vue?macro=true";
import { default as about_45passLs0cErLlUlaRNL0ah24oWcuowVm3tJwGKLAVsUSYwQMMeta } from "/codebuild/output/src296139272/src/src/pages/about-pass.vue?macro=true";
import { default as indexRefkf0MQvv0SDzOwsyXpyawQf48ubxwQHDH5EmhKlWwMeta } from "/codebuild/output/src296139272/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93_45z1o3Ses9VAviwAFJ0H7AXwkb_452Rzl9YqjvpSN1TrhoMeta } from "/codebuild/output/src296139272/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceAHUoIZkP_jNipOQujnwxLqtzSc3EVZgOXy4U_nms9IQMeta } from "/codebuild/output/src296139272/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_938cLooE7KAii5qOaTXR1T3gc3RAwIj0U53OJg29IsqVAMeta } from "/codebuild/output/src296139272/src/src/pages/notice/[id].vue?macro=true";
import { default as indexrKo2Q_rKkdQREUZ90s8Q3Z98UAtkmH2aoxEqRyR8HTkMeta } from "/codebuild/output/src296139272/src/src/pages/coupon/index.vue?macro=true";
import { default as indextppIkh_454TT7OdTu8iE9qpv_45A3gmgBPtwA9BZc8_45iX4sMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/index.vue?macro=true";
import { default as indexhGuCJrVHEiHNQkljlpdt7bumAVNliTs_45uLiTyXijYS4Meta } from "/codebuild/output/src296139272/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93qYiyKatKVEqRiE0w76URVnMQVA7Any64D__Q1fV46wsMeta } from "/codebuild/output/src296139272/src/src/pages/parking/[id].vue?macro=true";
import { default as index_nxSXKAuIABjbSPmhsPdOeFnG2CXYtLZN5lvoZmpZYgMeta } from "/codebuild/output/src296139272/src/src/pages/history/index.vue?macro=true";
import { default as index2tqPhn4UlpreMWslQGjcCHNE5n9eCWTM0FFz1uE4fVoMeta } from "/codebuild/output/src296139272/src/src/pages/monthly/index.vue?macro=true";
import { default as indexslXYEu7K5tA2UOwM3a7k7eiG7mtibrKvp5RXOmQhY44Meta } from "/codebuild/output/src296139272/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexccoJoLkKxXX0FqLzQQKiiQEnsbvFsCE1jTJRw1GEvPMMeta } from "/codebuild/output/src296139272/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviX4tC2AzTQkXUGn6PspTLKOpIGjGz9ivj_45EV7cxKA_45GcMeta } from "/codebuild/output/src296139272/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editYrE9gFAfHg3jY7jq8NTWNVuxxKyXbVKatroBPneONBAMeta } from "/codebuild/output/src296139272/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementDqy3wYf4D_5VhLwjpmCsaH90t6AIVzMnNYUANz1JSaIMeta } from "/codebuild/output/src296139272/src/src/pages/pass-agreement.vue?macro=true";
import { default as index1uozTcPjuSa_KHooTxg3T6memBQda8N1gyB3MexMrFoMeta } from "/codebuild/output/src296139272/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453diaWbUOb0qv0ra2aKUiLMKxCXnbu1SX5mUGMqYXPzO3gMeta } from "/codebuild/output/src296139272/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmKPHb4B1mwhXoWr0dI34jXOM9RMgEc_45FPZOq6NaIlXHsMeta } from "/codebuild/output/src296139272/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexHD8UkdZjz4t4L7mfUfGz4yltzT0kYHdRx8utOE30SSwMeta } from "/codebuild/output/src296139272/src/src/pages/card/create/index.vue?macro=true";
import { default as indexRLKbzOexObMKph9eORYNE1aO0IN876tOc6uu3WovqRYMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm2ek32UZv9sq2WFvZ2RunYAYmRJRPntGfyBJfSf61fFsMeta } from "/codebuild/output/src296139272/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmzCwsnMLgjovuh9wy6uslVerkelUUTOKxo1CYrmmH0DIMeta } from "/codebuild/output/src296139272/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeswEdQqnyukzh_45txIuBjW7u34_1GJG1anwAnT0Yx7DQsMeta } from "/codebuild/output/src296139272/src/src/pages/membership/complete.vue?macro=true";
import { default as registerw784A644c2gFKlhY7lnhLZFraJ6eUYlkWP_45FhloAB5gMeta } from "/codebuild/output/src296139272/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93llmmZqyzmmtzlxkOtIpKivIQoepcxyc8Vd_458xNEwo3IMeta } from "/codebuild/output/src296139272/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmkyj_454VDxnK4umFQ7AcdQ02XHrc_45LXrC6FmQFsmdMq70Meta } from "/codebuild/output/src296139272/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93DyF8lOv0f8SLxGrUVYXOmq_45NgM_tIkBW_T_GYXlV1MoMeta } from "/codebuild/output/src296139272/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexAYqAxu7sry3ArnCDNM8GCSSfw8z27MQiBKiGzaUg7WUMeta } from "/codebuild/output/src296139272/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45code2f2P_K_45v2ggZ_45qe3Ab3Ok0ohEBLvozJKegEP9nKtLx4Meta } from "/codebuild/output/src296139272/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codepl0RoQJb4kL5N0wuXSPtfatYCyJLFVjDIayTtDQ2BLQMeta } from "/codebuild/output/src296139272/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeYS5B1lAvfC1Lpo2itvPZGvlNtCS5qBoSp0eeLEfQRgUMeta } from "/codebuild/output/src296139272/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerh20l_45eHYvDc_45TDpeHJZpKtin0PRIsaEN3qJUtH0H1HIMeta } from "/codebuild/output/src296139272/src/src/pages/contact-form/register.vue?macro=true";
import { default as completetOR4OwIG_ih5FEuJ1Ve_U3A_45ZMgKrz8iUZzwC3O5_8AMeta } from "/codebuild/output/src296139272/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexM4gZmigfhGfn4cPcc_L_kUK1KLSqkxE30SghkPxQpvYMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirm3VVFx_45M017599uWW7ir8mqnGqVR2BrxHaX5D85mwXqUMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeWnc6tUV8gcTIjI1uy0hieTW1xVV_45ptQek3rPHc83j60Meta } from "/codebuild/output/src296139272/src/src/pages/reset-password/complete.vue?macro=true";
import { default as index83a_45fyRGhbSEoH3sHifF6UXWz5vQw2cpjluewG2KmHsMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_939OXkh_Gys_VGIjnhXp7nNcW_ioKm_jFpd_45IEY1rT8tgMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completecXkTGk0Um_ah6KOekZlI4GS5kJaAQF8Ip_45H14TZCr1gMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45alias9RqUju21S7RP5fE3QOuoPFnlz7lGB7tkLyb2XfBLVGkMeta } from "/codebuild/output/src296139272/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleqVNrTaStz_45KJE1cqjNJdMOGQWqOfHALKA6BzW5Q0gnEMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailPVnKBTrLsRZvuVLc2HrEQZLluB8jLo3BLgFkMquFw_45QMeta } from "/codebuild/output/src296139272/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirm3Ezh4vnUNthYrypk8_45bS6U0_ExKkivrPHiLWDKNCUwEMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentxp4jC1vpySeqD9U4Kqrej3xjVU7vYNwmg1Y1n0lM_45WkMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmyQpAN5Qy0vXCN0CJsUDvgZwmMegaboRI5_QD0PP_eoAMeta } from "/codebuild/output/src296139272/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatecYCiIbFi6WXx7M3atBXYEeXgCjSOzsRRjj3LiUQ3514Meta } from "/codebuild/output/src296139272/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completetl0ILHCcRtQiYg3hu6_RZL113uDUJ1Zp75axiQwNL4kMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeYbQnD_45E5YYblDqt_458c_45F6wCMQICc10oFo1gkd87I09wMeta } from "/codebuild/output/src296139272/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordHo87jEmI6vBNL1XESh9qV_45B_45AFYxZl8SfPNvtXNh8fIMeta } from "/codebuild/output/src296139272/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45alias73QNJTa3g_458cg0vyE1OkKMXVnVTui7uhYqAMDQwPX_sMeta } from "/codebuild/output/src296139272/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerfKCcr_45JWAc9OAwdes_S2AwxwbQpCrmC_45GOj_s2sLZJcMeta } from "/codebuild/output/src296139272/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeu0BMa8AGt7k3i7qQAmY9QTbmndc13nP0H5fI3dkN7GYMeta } from "/codebuild/output/src296139272/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexYV9hmXx28AIoL3cpq8qBkrweQ6moWMer_5mpvG8Rt8AMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexteM6Pi_q1dabaSa7daDWozvHxsd7v6bxN_45D0iX5qlAMMeta } from "/codebuild/output/src296139272/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexobB3y_45Q9Xlorha_455T_7oHvtkyLxbzIPbcmnBmZVf8vEMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexskVauB8dhxHzg1LJuW7q_45crkuS1rQA3J_45DUek5zIMCEMeta } from "/codebuild/output/src296139272/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update1zIghwdU9knuxxYt2u4wdUtOngkaaIEtCiQiZG0NL84Meta } from "/codebuild/output/src296139272/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete8M8Dy_45MGgAY4cHhXklzPtKw2f4SlVldW7WnqfE07EIUMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirm8Ou1xuS6SF83v4AvPJwyKIvoT_nqyapUco5e8Krj6U8Meta } from "/codebuild/output/src296139272/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as index17BE0Y28vYDMbD0GIYTbzsamYrPiaDziuIzgaHd1FN8Meta } from "/codebuild/output/src296139272/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completedb5ZWUVmOevvQPZPMOHc8Lypl22lryeOATUyLzWGtGMMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateDkiqAVd8f0_45AURPNiPckx4uTrtZPBPjLPIopFwLh73sMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexDhwMf76Rh77iY72AmTk_45EsYHQEQqpbUUWrDa1AzymWQMeta } from "/codebuild/output/src296139272/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexivGBglOG462JTqakZv1vBy3bHKQg07K0RgkE_45SMRzkgMeta } from "/codebuild/output/src296139272/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completewODML09ARle6_uobOCpglb_8HTnnxKQbDYbujFFi6IcMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexlO_Kbh4WirnGoL40gLlX6txH6YlajCGOuxV9CENNXCwMeta } from "/codebuild/output/src296139272/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeF7fL6YUbR9yon_45lLGER8OXHrJAKBbBRA2CMdkeDapDsMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexAVNbJVklV4kix_45WJrCRugiuLDAaNrXdPFLE3W_gT9FgMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexkPVxjiK_45_45P_45MyzLJR2eBPPTMwRxbEYTMxMRk8Gg1_45RAMeta } from "/codebuild/output/src296139272/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexU4fycWf2ZfhiqnsiKlmWk1BGXIJwzbowvhv0WUSNXXMMeta } from "/codebuild/output/src296139272/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateVOjJvXn5EWY743tZK10zFXYnu8oiS_45cLBQWtPeWVAMsMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmOFeD3XFmwNvGpstTzlGqylor3FnQjIGjZCbFTTDq6WwMeta } from "/codebuild/output/src296139272/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src296139272/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu1T_45V9TPVSwssIzSjqiUS8jTHtH3E8FnGFhnsls6Pt7sMeta || {},
    component: () => import("/codebuild/output/src296139272/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indextKkocOkBoDt_45wgiEhv9Yr2ElwoeB3I9Ch9IQhEPpIpMMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src296139272/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src296139272/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src296139272/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src296139272/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src296139272/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src296139272/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src296139272/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src296139272/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src296139272/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexrKo2Q_rKkdQREUZ90s8Q3Z98UAtkmH2aoxEqRyR8HTkMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src296139272/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src296139272/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src296139272/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index_nxSXKAuIABjbSPmhsPdOeFnG2CXYtLZN5lvoZmpZYgMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src296139272/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src296139272/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexslXYEu7K5tA2UOwM3a7k7eiG7mtibrKvp5RXOmQhY44Meta || {},
    component: () => import("/codebuild/output/src296139272/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexccoJoLkKxXX0FqLzQQKiiQEnsbvFsCE1jTJRw1GEvPMMeta || {},
    component: () => import("/codebuild/output/src296139272/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src296139272/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src296139272/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src296139272/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src296139272/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src296139272/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src296139272/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexHD8UkdZjz4t4L7mfUfGz4yltzT0kYHdRx8utOE30SSwMeta || {},
    component: () => import("/codebuild/output/src296139272/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm2ek32UZv9sq2WFvZ2RunYAYmRJRPntGfyBJfSf61fFsMeta || {},
    component: () => import("/codebuild/output/src296139272/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmzCwsnMLgjovuh9wy6uslVerkelUUTOKxo1CYrmmH0DIMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src296139272/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeswEdQqnyukzh_45txIuBjW7u34_1GJG1anwAnT0Yx7DQsMeta || {},
    component: () => import("/codebuild/output/src296139272/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerw784A644c2gFKlhY7lnhLZFraJ6eUYlkWP_45FhloAB5gMeta || {},
    component: () => import("/codebuild/output/src296139272/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src296139272/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmkyj_454VDxnK4umFQ7AcdQ02XHrc_45LXrC6FmQFsmdMq70Meta || {},
    component: () => import("/codebuild/output/src296139272/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src296139272/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src296139272/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45code2f2P_K_45v2ggZ_45qe3Ab3Ok0ohEBLvozJKegEP9nKtLx4Meta || {},
    component: () => import("/codebuild/output/src296139272/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codepl0RoQJb4kL5N0wuXSPtfatYCyJLFVjDIayTtDQ2BLQMeta || {},
    component: () => import("/codebuild/output/src296139272/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeYS5B1lAvfC1Lpo2itvPZGvlNtCS5qBoSp0eeLEfQRgUMeta || {},
    component: () => import("/codebuild/output/src296139272/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerh20l_45eHYvDc_45TDpeHJZpKtin0PRIsaEN3qJUtH0H1HIMeta || {},
    component: () => import("/codebuild/output/src296139272/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src296139272/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirm3VVFx_45M017599uWW7ir8mqnGqVR2BrxHaX5D85mwXqUMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeWnc6tUV8gcTIjI1uy0hieTW1xVV_45ptQek3rPHc83j60Meta || {},
    component: () => import("/codebuild/output/src296139272/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(index83a_45fyRGhbSEoH3sHifF6UXWz5vQw2cpjluewG2KmHsMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completecXkTGk0Um_ah6KOekZlI4GS5kJaAQF8Ip_45H14TZCr1gMeta || {},
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src296139272/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleqVNrTaStz_45KJE1cqjNJdMOGQWqOfHALKA6BzW5Q0gnEMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailPVnKBTrLsRZvuVLc2HrEQZLluB8jLo3BLgFkMquFw_45QMeta || {},
    component: () => import("/codebuild/output/src296139272/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirm3Ezh4vnUNthYrypk8_45bS6U0_ExKkivrPHiLWDKNCUwEMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentxp4jC1vpySeqD9U4Kqrej3xjVU7vYNwmg1Y1n0lM_45WkMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmyQpAN5Qy0vXCN0CJsUDvgZwmMegaboRI5_QD0PP_eoAMeta || {},
    component: () => import("/codebuild/output/src296139272/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src296139272/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completetl0ILHCcRtQiYg3hu6_RZL113uDUJ1Zp75axiQwNL4kMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeYbQnD_45E5YYblDqt_458c_45F6wCMQICc10oFo1gkd87I09wMeta || {},
    component: () => import("/codebuild/output/src296139272/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordHo87jEmI6vBNL1XESh9qV_45B_45AFYxZl8SfPNvtXNh8fIMeta || {},
    component: () => import("/codebuild/output/src296139272/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src296139272/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerfKCcr_45JWAc9OAwdes_S2AwxwbQpCrmC_45GOj_s2sLZJcMeta || {},
    component: () => import("/codebuild/output/src296139272/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeu0BMa8AGt7k3i7qQAmY9QTbmndc13nP0H5fI3dkN7GYMeta || {},
    component: () => import("/codebuild/output/src296139272/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src296139272/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src296139272/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src296139272/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src296139272/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src296139272/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src296139272/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src296139272/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src296139272/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src296139272/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]